import { render, staticRenderFns } from "./TossPaymentConfigIframe.vue?vue&type=template&id=c8bda9c0&"
import script from "./TossPaymentConfigIframe.vue?vue&type=script&lang=ts&"
export * from "./TossPaymentConfigIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports